var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(0.019 0.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_798_",
    transform: "translate(13.111 10.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_799_",
    d: "M46.67,1.926A7.775,7.775,0,0,0,41.381,0a8.528,8.528,0,0,0-6.132,2.253,6.508,6.508,0,0,0-2.067,4.615c0,2.092.918,3.7,2.456,4.295a.848.848,0,0,0,.309.061.68.68,0,0,0,.67-.527c.052-.186.172-.645.224-.845a.768.768,0,0,0-.223-.857,2.65,2.65,0,0,1-.652-1.866A4.817,4.817,0,0,1,41.077,2.4c2.634,0,4.27,1.427,4.27,3.723A7.442,7.442,0,0,1,44.425,9.9a2.725,2.725,0,0,1-2.256,1.5,1.527,1.527,0,0,1-1.19-.518,1.256,1.256,0,0,1-.24-1.133c.117-.474.278-.968.432-1.445a8.585,8.585,0,0,0,.55-2.353,1.745,1.745,0,0,0-1.8-1.88c-1.372,0-2.447,1.328-2.447,3.023a4.313,4.313,0,0,0,.337,1.692c-.173.7-1.2,4.846-1.395,5.628-.113.457-.791,4.063.332,4.351,1.262.323,2.39-3.189,2.5-3.586.093-.323.419-1.543.618-2.294a3.922,3.922,0,0,0,2.545.937,5.775,5.775,0,0,0,4.556-2.172,8.44,8.44,0,0,0,1.713-5.332A6.017,6.017,0,0,0,46.67,1.926Z",
    transform: "translate(-33.181 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    transform: "translate(-0.019 -0.204)",
    fill: "none",
    stroke: "#9c9ca8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestIcon);
export default __webpack_public_path__ + "static/media/Pinterest Icon.878d96b54815aa0ffeb88ac5807fb9d8.svg";
export { ForwardRef as ReactComponent };